import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, ShieldCheckIcon, CalendarIcon, ClipboardCheckIcon, UtensilsIcon, GiftIcon, HeadphonesIcon } from 'lucide-react';
export function DeliverablesSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="w-full bg-cream py-20 px-4" data-id="element-34">
      <div className="max-w-5xl mx-auto" data-id="element-35">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-36">
          <h2 className="font-heading text-3xl sm:text-4xl text-charcoal mb-4" data-id="element-37">
            Lo que recibes
          </h2>
          <p className="font-body text-warmGray text-lg" data-id="element-38">
            Todo lo que necesitas para transformar las noches de tu familia
          </p>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-6" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-39">
          <motion.div className="bg-warmWhite rounded-2xl p-6 shadow-warm border border-terracotta-100" variants={itemVariants} data-id="element-40">
            <div className="flex items-start gap-4" data-id="element-41">
              <div className="flex-shrink-0 w-12 h-12 bg-terracotta-100 rounded-xl flex items-center justify-center" data-id="element-42">
                <BookOpenIcon className="w-6 h-6 text-terracotta" data-id="element-43" />
              </div>
              <div data-id="element-44">
                <h3 className="font-heading text-xl text-charcoal mb-2" data-id="element-45">
                  eBook Formato PDF
                </h3>
                <p className="font-body text-warmGray" data-id="element-46">
                  La guía completa con el método paso a paso.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div className="bg-warmWhite rounded-2xl p-6 shadow-warm border border-terracotta-100" variants={itemVariants} data-id="element-47">
            <div className="flex items-start gap-4" data-id="element-48">
              <div className="flex-shrink-0 w-12 h-12 bg-terracotta-100 rounded-xl flex items-center justify-center" data-id="element-49">
                <ShieldCheckIcon className="w-6 h-6 text-terracotta" data-id="element-50" />
              </div>
              <div data-id="element-51">
                <h3 className="font-heading text-xl text-charcoal mb-2" data-id="element-52">
                  Protocolo Cero Llanto
                </h3>
                <p className="font-body text-warmGray" data-id="element-53">
                  La técnica exacta para calmar despertares sin lágrimas.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div className="bg-warmWhite rounded-2xl p-6 shadow-warm border border-terracotta-100" variants={itemVariants} data-id="element-54">
            <div className="flex items-start gap-4" data-id="element-55">
              <div className="flex-shrink-0 w-12 h-12 bg-terracotta-100 rounded-xl flex items-center justify-center" data-id="element-56">
                <CalendarIcon className="w-6 h-6 text-terracotta" data-id="element-57" />
              </div>
              <div data-id="element-58">
                <h3 className="font-heading text-xl text-charcoal mb-2" data-id="element-59">
                  Bitácora de 7 Días
                </h3>
                <p className="font-body text-warmGray" data-id="element-60">
                  Una hoja de seguimiento para identificar las ventanas de sueño
                  de tu bebé.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div className="bg-warmWhite rounded-2xl p-6 shadow-warm border border-terracotta-100" variants={itemVariants} data-id="element-61">
            <div className="flex items-start gap-4" data-id="element-62">
              <div className="flex-shrink-0 w-12 h-12 bg-terracotta-100 rounded-xl flex items-center justify-center" data-id="element-63">
                <ClipboardCheckIcon className="w-6 h-6 text-terracotta" data-id="element-64" />
              </div>
              <div data-id="element-65">
                <h3 className="font-heading text-xl text-charcoal mb-2" data-id="element-66">
                  Checklist de Santuario
                </h3>
                <p className="font-body text-warmGray" data-id="element-67">
                  Lista de verificación para configurar la habitación perfecta.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div className="bg-gradient-to-r from-sage-50 to-sage-100 rounded-2xl p-6 shadow-warm border border-sage-200" variants={itemVariants} data-id="element-68">
            <div className="flex items-start gap-4" data-id="element-69">
              <div className="flex-shrink-0 w-12 h-12 bg-sage rounded-xl flex items-center justify-center" data-id="element-70">
                <GiftIcon className="w-6 h-6 text-white" data-id="element-71" />
              </div>
              <div data-id="element-72">
                <div className="flex items-center gap-2 mb-1" data-id="element-73">
                  <span className="text-xs font-semibold text-sage uppercase tracking-wider bg-white px-2 py-0.5 rounded-full" data-id="element-74">
                    Bono 1
                  </span>
                </div>
                <h3 className="font-heading text-xl text-charcoal mb-2" data-id="element-75">
                  La Guía Paso a Paso para Alimentar sin Gases y Dormir de Tirón
                </h3>
                <p className="font-body text-warmGray" data-id="element-76">
                  Aprende la técnica exacta de alimentación que elimina gases y
                  permite que tu bebé duerma bloques largos sin interrupciones.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div className="bg-gradient-to-r from-sage-50 to-sage-100 rounded-2xl p-6 shadow-warm border border-sage-200" variants={itemVariants} data-id="element-77">
            <div className="flex items-start gap-4" data-id="element-78">
              <div className="flex-shrink-0 w-12 h-12 bg-sage rounded-xl flex items-center justify-center" data-id="element-79">
                <HeadphonesIcon className="w-6 h-6 text-white" data-id="element-80" />
              </div>
              <div data-id="element-81">
                <div className="flex items-center gap-2 mb-1" data-id="element-82">
                  <span className="text-xs font-semibold text-sage uppercase tracking-wider bg-white px-2 py-0.5 rounded-full" data-id="element-83">
                    Bono 2
                  </span>
                </div>
                <h3 className="font-heading text-xl text-charcoal mb-2" data-id="element-84">
                  Domador de Cólicos Nocturnos + Audio Guía de Emergencia
                </h3>
                <p className="font-body text-warmGray" data-id="element-85">
                  Protocolo de alivio inmediato para cólicos nocturnos con una
                  audio guía que puedes escuchar en el momento que más lo
                  necesitas.
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}